export const MARKET_EXCEPTIONS = 'market-exceptions';
export const QR_SKELETON = 'qr-skeleton';
